import {
  AnnouncementDetails,
  SelectAnnouncementStatuses,
} from '../shared/models/announcement-detail-model';
import { ApplicationMessageSource } from '../../core/models/application-message-source';
import { MessageType } from '../../core/models/enum/message-type';
import { ApplicationMessage } from '../../core/models/application-message';
import { CustomMessageService } from '../../core/message.service';
import { Utils } from '../../shared/utils';
import { Patterns } from '../../shared/validation/patterns';
import { ValidationUtils } from '../../shared/validation/validation-runner';
import { IValidator, Validator } from '../../shared/validation/validators';
import { FieldState } from '../../shared/models/field-state';
import { CustomerService } from '../../customers/shared/services/customer.service';
import { CommonLookupItem } from '../../shared/models/common-lookup-item.model';
import { CustomerModel } from '../../customers/shared/models/customer-model';
import { LookupService } from '../../shared/services/lookup.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { AnnouncementService } from '../shared/services/announcement.service';
import { PagingFilter } from '../../shared/models/paging-filter.model';
import {
  AnnouncementFilterModel,
  CustomerOptionList,
} from '../shared/models/announcement-filter-model';
import { AnnouncementModel } from '../shared/models/announcement-model';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { UserService } from '@admin/core/user.service';
import { FeatureEnum } from '@admin/shared/models/feature-enum';
import { Table } from 'primeng/table';
import { PortfolioService } from '@admin/portfolios/shared/services/portfolio.service';
import { PortfolioAccountManagerAdminModel } from '@admin/portfolios/shared/models/portfolio-account-manager-admin-model';
import { PortfolioModel } from '@admin/portfolios/shared/models/portfolio-model';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationMethodEnum } from '../shared/enums/announcement-enums';

@Component({
  selector: 'hr-announcement-list',
  templateUrl: './announcement-list.component.html',
  styleUrls: ['./announcement-list.component.less'],
  standalone: false,
})
export class AnnouncementListComponent implements OnInit {
  public filterPagingWrapper: PagingFilter<AnnouncementFilterModel>;

  public switchFilterStatuses: SelectAnnouncementStatuses[];
  public switchFilterStatus: number;
  public SwitchFilterStatus: any = AnnouncementStatus;

  public switchModerationStatuses: SelectAnnouncementStatuses[];

  public switchOnWebsiteStatuses: SelectItem[];

  public announcementList: AnnouncementModel[];

  public hasAnnouncementCancelPermission: boolean;

  public totalRecords: number;

  public applicationMethod: any;

  public announcementStatus: any;

  public totalModeration: number;

  public lastLoadEvent: LazyLoadEvent;

  public accountManagers: PortfolioAccountManagerAdminModel[];

  public pageSize: number;

  public providerWebsiteList: CommonLookupItem<number, string>[];

  public isReset: boolean;

  public portfolios: PortfolioModel[];

  public currentDate: Date;

  public dateFormat: string;
  public specialDateFormat: string;

  public customerList: CustomerOptionList[];

  public fieldStates: { title: FieldState };

  public get field() {
    return this.fieldStates;
  }

  constructor(
    private lookupService: LookupService,
    private config: ConfigurationService,
    private announcementService: AnnouncementService,
    private customerService: CustomerService,
    private messageService: CustomMessageService,
    private userService: UserService,
    private portfolioService: PortfolioService,
    private translationService: TranslateService
  ) {
    this.announcementStatus = AnnouncementStatus;
    this.filterPagingWrapper = new PagingFilter(new AnnouncementFilterModel());
    this.switchFilterStatus = AnnouncementStatus.All;
    this.providerWebsiteList = [];
    this.customerList = [];
    this.accountManagers = [];
    this.applicationMethod = ApplicationMethodEnum;
  }

  onLoad(event: LazyLoadEvent) {
    if (this.isReset) {
      this.announcementList = [];
      this.totalRecords = 0;
      return;
    }

    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: Utils.capitalizeFirstLetter(event.sortField),
          order: event.sortOrder == 1 ? 'Asc' : 'Desc',
        },
      ];
    }

    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    this.lastLoadEvent = event;
    this.initializeFieldsState();
    this.onFilter();
  }

  public getLabel(inModeration: boolean, label: string) {
    if (inModeration) {
      if (this.totalModeration != null) {
        return `${label}(${this.totalModeration})`;
      } else {
        return `${label}(0)`;
      }
    } else {
      return `${label}`;
    }
  }

  onFilter() {
    this.filterPagingWrapper.pagingInfo.start =
      this.filterPagingWrapper.pagingInfo.start || 0;
    this.filterPagingWrapper.filter.selectedStatusId = this.switchFilterStatus;
    let varlidators = this.getValidators();
    this.invokeValidation(varlidators, () => {
      this.announcementService
        .listAnnouncements(this.filterPagingWrapper)
        .subscribe((d) => {
          this.totalRecords = d.totalCount;
          this.announcementList = d.items;
        });
    });
    this.announcementService
      .getModerationAnnouncementCount()
      .subscribe((x) => (this.totalModeration = x.data.totalModerationCount));
  }

  onApplyClick(dt: Table, value?: AnnouncementStatus) {
    if (value) {
      this.switchFilterStatus = value;
    }
    this.filterPagingWrapper.pagingInfo.start = 0;
    //TODO: bug in paginator, does not update state correctly, change this code after bug is fixed in framework (primeng)
    this.isReset = true;
    dt.reset();
    for (let key in dt.expandedRowKeys) {
      dt.expandedRowKeys[key] = false;
    }
    this.isReset = false;
    this.initializeFieldsState();
    this.onFilter();
  }

  onClearClick() {
    this.filterPagingWrapper = new PagingFilter(new AnnouncementFilterModel());
    this.initializeFieldsState();
  }

  getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  public filterCustomer(event) {
    this.customerService.listCustomerByName(event.query).subscribe((c) => {
      this.customerList = c.map((v) => {
        return {
          id: v.value,
          label: v.text,
        };
      });
    });
  }

  public initializeFieldsState() {
    this.fieldStates = {
      title: new FieldState(
        () =>
          this.filterPagingWrapper &&
          this.filterPagingWrapper.filter &&
          this.filterPagingWrapper.filter.announcementTitle
      ),
    };
  }

  public invokeValidation(validators: IValidator[], onValid?: () => void) {
    ValidationUtils.invokeValidation(
      validators,
      this.getFieldStatesObject(),
      onValid
    );
  }

  private getFieldStatesObject(): { [index: string]: FieldState } {
    let result: { [index: string]: FieldState } = {};
    for (let p in this.fieldStates) {
      if (this.fieldStates.hasOwnProperty(p)) {
        result[this.fieldStates[p].fieldId] = this.fieldStates[p];
      }
    }

    return result;
  }

  private getValidators() {
    let field = this.field;
    let anouncementTitle =
      this.filterPagingWrapper &&
      this.filterPagingWrapper.filter &&
      this.filterPagingWrapper.filter.announcementTitle;
    let minSymbols = this.translationService.instant('message.Min 3 Symbols');

    return [
      Validator.forNotRequired(field.title, () => anouncementTitle),
      Validator.forPattern(
        field.title,
        () => anouncementTitle,
        Patterns.textField,
        minSymbols
      ),
    ];
  }

  public onActivateClick(announcementId: number) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }

    this.announcementService
      .activateAnnouncement(announcementId)
      .subscribe((result) => {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: this.translationService.instant('message.SaveMessage'),
        });
        this.onLoad(this.lastLoadEvent);
      });
    if (this.announcementList && this.announcementList.length == 1) {
      let offset = this.lastLoadEvent.first - this.lastLoadEvent.rows;
      if (offset >= 0) {
        this.lastLoadEvent.first = offset;
      }
    }
    this.onLoad(this.lastLoadEvent);
  }

  public getBorderColors(announcement) {
    if (announcement.hasPendingUpgrade) return AnnouncementColors.Yellow;
    else if (
      announcement.hasPendingChanges &&
      announcement.announcementStatusId !== AnnouncementStatus.Pending
    ) {
      return AnnouncementColors.Orange;
    } else if (
      announcement.announcementStatusId === AnnouncementStatus.Pending
    ) {
      return AnnouncementColors.Red;
    } else if (
      announcement.announcementStatusId === AnnouncementStatus.Active &&
      announcement.publishStatusId === AnnouncementPublishStatus.NotPublished
    ) {
      return AnnouncementColors.Green;
    } else {
      return AnnouncementColors.Deleted;
    }
  }

  public refresh() {
    this.onLoad(this.lastLoadEvent);
  }

  public onDeactivateClick(announcementId: number) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }

    this.announcementService
      .deactivateAnnouncement(announcementId)
      .subscribe((result) => {
        this.messageService.pushMessage(<ApplicationMessage>{
          type: MessageType.Success,
          sourceId: ApplicationMessageSource.global,
          summary: '',
          detail: this.translationService.instant('message.SaveMessage'),
        });
        if (this.announcementList && this.announcementList.length == 1) {
          let offset = this.lastLoadEvent.first - this.lastLoadEvent.rows;
          if (offset >= 0) {
            this.lastLoadEvent.first = offset;
          }
        }
        this.onLoad(this.lastLoadEvent);
      });
  }

  public onAnnouncementCancel(announcementId: number) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }

    this.announcementService
      .cancelAnnouncement(announcementId)
      .subscribe((d) => {
        this.refresh();
      });
  }

  onToggleAnnouncementCapture(announcementId: number, hasCaptureCv: boolean) {
    if (!confirm(this.translationService.instant('message.AreYouSure'))) {
      return;
    }

    this.announcementService
      .changeAnnouncementCaptureStatus(announcementId, !hasCaptureCv)
      .subscribe((d) => {
        this.refresh();
      });
  }

  public onExpandClick(event: any) {
    this.announcementService
      .getAnnouncementDetails(event.data.announcementId)
      .subscribe((s) => {
        event.data.announcementDetails = s.data;
      });
  }

  ngOnInit() {
    this.announcementService
      .getModerationAnnouncementCount()
      .subscribe((x) => (this.totalModeration = x.data.totalModerationCount));
    let lookupData = this.lookupService.getCachedLookupData();
    this.providerWebsiteList = lookupData.providerWebsiteList;
    let config = this.config.getCachedConfig();
    this.pageSize = config.defaultPageSize;
    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);
    this.currentDate = new Date();
    this.hasAnnouncementCancelPermission =
      this.userService.currentUser.features.some(
        (f) => f == FeatureEnum.MergeAndUnmergeInvoices
      );
    this.initializeFieldsState();
    this.portfolioService.accountManagerList().subscribe((a) => {
      this.accountManagers = a.items;
    });
    this.portfolioService.getPortfolios().subscribe((p) => {
      this.portfolios = p.items;
    });
    this.switchFilterStatuses = [
      {
        label: this.translationService.instant('label.All'),
        value: AnnouncementStatus.All,
        styleClass: 'all-button',
        isInModeration: false,
      },
      {
        label: this.translationService.instant('label.Moderation'),
        value: AnnouncementStatus.Pending,
        styleClass: 'moderation-button',
        isInModeration: true,
      },
      {
        label: this.translationService.instant('label.Active'),
        value: AnnouncementStatus.Active,
        styleClass: 'active-button',
        isInModeration: false,
      },
      {
        label: this.translationService.instant('label.Expired'),
        value: AnnouncementStatus.Expired,
        styleClass: 'expired-button',
        isInModeration: false,
      },
      {
        label: this.translationService.instant('label.Deactivated'),
        value: AnnouncementStatus.Deactived,
        styleClass: 'deactivated-button',
        isInModeration: false,
      },
      {
        label: this.translationService.instant(
          'label.CanceledAnnouncementStatus'
        ),
        value: AnnouncementStatus.Canceled,
        styleClass: 'cancelled-button',
        isInModeration: false,
      },
      {
        label: this.translationService.instant('label.Rejected'),
        value: AnnouncementStatus.Rejected,
        styleClass: 'rejected-button',
        isInModeration: false,
      },
    ];
    this.switchModerationStatuses = [
      {
        label: this.translationService.instant('label.All'),
        value: ModerationStatus.All,
      },
      {
        label: this.translationService.instant('label.New'),
        value: ModerationStatus.New,
      },
      {
        label: this.translationService.instant('label.Edited'),
        value: ModerationStatus.Edited,
      },
    ];
    this.switchOnWebsiteStatuses = [
      {
        label: this.translationService.instant('label.All'),
        value: OnWebsiteStatus.All,
      },
      {
        label: this.translationService.instant('label.Yes'),
        value: OnWebsiteStatus.OnWebsite,
      },
      {
        label: this.translationService.instant('label.No'),
        value: OnWebsiteStatus.NotOnWebsite,
      },
    ];
  }
}

export enum AnnouncementStatus {
  Active = 1,
  Deactived = 2,
  Expired = 3,
  Canceled = 4,
  Pending = 5,
  Rejected = 6,
  All = 7,
}

export enum AnnouncementColors {
  Green = '#85C226',
  Red = '#F00',
  Yellow = '#F7CD3A',
  Orange = '#FF6500',
  Deleted = '#e2e8f0',
}

export enum ModerationStatus {
  All = 1,
  New = 2,
  Edited = 3,
}

export enum OnWebsiteStatus {
  All = 1,
  OnWebsite = 2,
  NotOnWebsite = 3,
}

export enum AnnouncementPublishStatus {
  NotPublished = 1,
  LimitedPublish = 2,
  Published = 3,
  UnPublished = 4,
}
